const fallback = `data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 100"><rect width="160" height="100" fill="#202530"/><path d="M65 32L100 50L65 68Z" fill="#8b93a6"/></svg>')}`;

export function AssetThumbnail({ assetId }: { assetId: string }) {
  return <img
    key={assetId}
    src={`/api/assets/${encodeURIComponent(assetId)}/thumbnail`}
    alt=""
    loading="lazy"
    onError={({ currentTarget }) => {
      if (currentTarget.src !== fallback) currentTarget.src = fallback;
    }}
  />;
}
